import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// constants
import { managementZonesTypes } from 'constants/scripts';

// components
import LoadingWrapperContainer from 'api/loading/LoadingWrapperContainer';
import QuitFlowModalContainer from 'common/modals/QuitFlowModalContainer';
import ScriptFlowHeader from 'common/ScriptFlowHeader';
import ScriptFlowBody from 'common/ScriptFlowBody';
import MessagePanel from 'messages/MessagePanel';

import ManagementZonesContainer from 'manual/ManagementZonesContainer';
import PlantingPlanContainer from 'manual/PlantingPlanContainer';
import SelectScript from 'manual/SelectScript';
import ZoneGenerationSelectionContainer from 'manual/ZoneGenerationSelectionContainer';
import ZoneGenerationReviewContainer from 'manual/ZoneGenerationReviewContainer';
import ZoneGenerationLayersSelection from 'manual/ZoneGenerationLayersSelection';

const steps = {
  1: ManagementZonesContainer,
  2: PlantingPlanContainer
};

const previousScriptSteps = {
  1: ManagementZonesContainer,
  2: SelectScript,
  3: PlantingPlanContainer
};

const generateZonesSteps = {
  1: ManagementZonesContainer,
  2: ZoneGenerationSelectionContainer,
  3: ZoneGenerationReviewContainer,
  4: PlantingPlanContainer
};

const importedScriptsSteps = {
  1: ManagementZonesContainer,
  2: SelectScript,
  3: PlantingPlanContainer
};

const ManualScript = ({
  canGoBack,
  canGoForward,
  closeMessage,
  initialLoadIsInProgress,
  isFinalStep,
  isMultiLayerEnabled,
  messages,
  onClickBack,
  onClickCancel,
  onClickForward,
  selectedManagementZonesType,
  stepNumber
}) => {

  const classString = classNames({
    'vra-manual-script': true,
    'vra-route-container': true,
    'vra-route-container--script-flow': true,
    'vra-route-container--manual': true
  });

  let Content;

  // set appropriate content for each script type such as previous prescription and imported scripts
  switch (selectedManagementZonesType) {
    case managementZonesTypes.PREVIOUS_PRESCRIPTION:
      Content = previousScriptSteps[stepNumber];
      break;
    case managementZonesTypes.GENERATE_ZONES:
      Content = (isMultiLayerEnabled && stepNumber === 2)
        ? ZoneGenerationLayersSelection : generateZonesSteps[stepNumber];
      break;
    case managementZonesTypes.IMPORTED_MAPS_PARENT:
      Content = importedScriptsSteps[stepNumber];
      break;
    default:
      Content = steps[stepNumber];
      break;
  }

  return (
    <LoadingWrapperContainer initialLoadIsInProgress={initialLoadIsInProgress}>
      <section className={classString}>
        <MessagePanel
          closeMessage={closeMessage}
          isToolbarShown={false}
          messages={messages}
        />
        <ScriptFlowHeader
          onClickCancel={() => onClickCancel(stepNumber)}
        />
        <ScriptFlowBody
          canGoBack={canGoBack}
          canGoForward={canGoForward}
          isFinalStep={isFinalStep}
          isMultiLayerEnabled={isMultiLayerEnabled}
          onClickBack={onClickBack}
          onClickForward={onClickForward}>
          {Content && <Content />}
        </ScriptFlowBody>
        <QuitFlowModalContainer />
      </section>
    </LoadingWrapperContainer>
  );
};

ManualScript.propTypes = {
  canGoBack: propTypes.bool.isRequired,
  canGoForward: propTypes.bool.isRequired,
  closeMessage: propTypes.func.isRequired,
  initialLoadIsInProgress: propTypes.bool.isRequired,
  isFinalStep: propTypes.bool.isRequired,
  isMultiLayerEnabled: propTypes.bool.isRequired,
  messages: propTypes.array.isRequired,
  onClickBack: propTypes.func.isRequired,
  onClickCancel: propTypes.func.isRequired,
  onClickForward: propTypes.func.isRequired,
  selectedManagementZonesType: propTypes.string.isRequired,
  stepNumber: propTypes.number.isRequired
};

export default ManualScript;
